import {Text} from '@eitje/web_components'

export const CapitalRow = ({item}) => {
	return (
		<>
			<Text t={`records.default.fields.${item.description}`} infoIconMessage={item.infoIconMessage} />
			<Text>{item.value?.toUpperCase()}</Text>
		</>
	)
}
